module.exports = __webpack_public_path__ + "img/aside-left-board.2d1236b0.png";